import URL from "core/resources/urls";
import http from "infra/http";
import { useQuery } from "react-query";
import { ProdutividadeMap, TipoMapaTalhoes } from "../typings";

export function useProdutividade(
  unidadeId: string,
  safraId: string,
  tipoMapa: TipoMapaTalhoes
) {
  return useQuery(
    URL.MAPAS.PRODUTIVIDADE(unidadeId!, safraId!),
    async () => {
      if (unidadeId && safraId) {
        const { data } = await http.get<ProdutividadeMap>(
          URL.MAPAS.PRODUTIVIDADE(unidadeId!, safraId!)
        );

        return data;
      }
    },
    {
      enabled: tipoMapa === TipoMapaTalhoes.Produtividade,
    }
  );
}
